/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Ura',
    titleMeta: 'Ura — Avoimet työpaikat | CamDiab',
    descriptionMeta: 'Tutustu uramahdollisuuksiin CamDiabilla. Liity tiimiimme, joka parantaa elämää diabeteksen kanssa.',
    keywords: 'CamDiab ura, työpaikat, avoimet, diabetes',
    localeMeta: 'fi_fi',

    bannerTitle: 'Avoimet työpaikat',
    bannerSubtitle: 'Haluatko liittyä tiimiimme?',
    heroNote: 'Kaikki ilmoitukset julkaistaan englanniksi.',

    introBody:
        'Etsitkö uutta haastetta ja haluat olla mukana luomassa merkityksellistä muutosta? Kuulemme mielellämme sinusta. Panostamme ihmisiimme — CamDiabin sykkivään sydämeen. Työntekijöiden edut on suunniteltu tuomaan esiin parasta jokaisesta, mukaan lukien:',

    benefitsTitle: '',
    benefits: [
        'Antelias työnantajan eläkemaksu',
        'Täydentävä sairausvakuutus',
        'Henkivakuutus',
        'Vuosittainen harkinnanvarainen bonus',
        '29 vuorokautta vuosilomaa plus 8 arkipyhää',
        'Mahdollisuus työskennellä uraauurtavassa teknologiassa, jolla voi muuttaa diabeteksen hoitoa ja parantaa potilastuloksia',
        'Yhteistyöhenkinen ja dynaaminen työympäristö',
        'Kilpailukykyinen palkka ja edut, mukaan lukien ammatillinen kehitys ja uralla eteneminen',
    ],

    outroHtml:
        'Jos intohimosi on todellinen vaikutus käytännössä, kuulemme mielellämme sinusta:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'Ei avoimia paikkoja',
    emptyVacancyBody:
        'Emme ehkä juuri nyt rekrytoi, mutta CamDiab kasvaa, ja kuulemme mielellämme ihmisistä, jotka haluavat parantaa elämää diabeteksen kanssa. Tule myöhemmin uudelleen.',

    applyLabel: 'Hae nyt',
};
